export type KeyOfType<TObj, TPropType> = {
  [K in keyof TObj]-?: TObj[K] extends TPropType ? K : never;
}[keyof TObj];

/**
 * When you need a property that can accept values of given types but may also contain other
 */
export type KeyOfTypeContravariant<TObj, TPropType> = {
  [K in keyof TObj]-?: TPropType extends TObj[K] ? K : never;
}[keyof TObj];

/**
 * Typescript is not able to determine that TObject[KeyOfType<TObject, TValueType>] = TValueType
 * when TObject goes over some generic.
 *
 * This helper method encapsulates the type cast needed to access a typed value this way.
 *
 * @example
 * const renderTimestampField = <T>(key: KeyOfType<T, Date>) =>
 *   (obj: T) =>
 *     getValueFromKeyOfType(obj, key).getTime();
 */
export const getValueFromKeyOfType = <TObject, TValueType>(
  object: TObject,
  key: KeyOfType<TObject, TValueType>,
): TValueType => object[key] as unknown as TValueType;
